import { useWindowDimensions } from 'react-native';

import { useTheme } from '@providers/Theme';

export function useIsMobile() {
  const theme = useTheme();
  const { width } = useWindowDimensions();

  return width < theme.breakpoints.md;
}
